import { render } from "./AccountOnHold.vue?vue&type=template&id=2f288b1a&scoped=true"
import script from "./AccountOnHold.vue?vue&type=script&lang=js"
export * from "./AccountOnHold.vue?vue&type=script&lang=js"

import "./AccountOnHold.vue?vue&type=style&index=0&id=2f288b1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f288b1a"]])

export default __exports__